export type CommercialListingKey = 'leads' | 'declined';

export type CommercialListingItem = {
  key: CommercialListingKey;
  label: string;
  path: string;
};

export const COMMERCIAL_LISTING_ITEMS: CommercialListingItem[] = [
  { key: 'leads', label: 'Leads', path: '/comercial' },
  { key: 'declined', label: 'Declinadas', path: '/comercial/declinadas' },
];

export const getCommercialListingPath = (key: CommercialListingKey): string => (
  key === 'declined' ? '/comercial/declinadas' : '/comercial'
);

export const isCommercialPath = (pathname: string): boolean => (
  pathname === '/comercial' || pathname.startsWith('/comercial/')
);

export const getCommercialListingMode = (pathname: string): CommercialListingKey => (
  pathname === '/comercial/declinadas' ? 'declined' : 'leads'
);

export const showsCommercialPaymentAndCheckout = (
  listingMode: CommercialListingKey,
): boolean => listingMode !== 'declined';

export const COMMERCIAL_LEADS_GRID_TEMPLATE =
  'minmax(180px, 1.6fr) minmax(148px, 1.1fr) minmax(160px, 1.2fr) minmax(176px, 1.2fr) minmax(120px, 1fr) minmax(160px, 1.3fr) 96px 120px 168px';

export const COMMERCIAL_DECLINED_GRID_TEMPLATE =
  'minmax(180px, 1.6fr) minmax(148px, 1.1fr) minmax(160px, 1.2fr) minmax(176px, 1.2fr) minmax(120px, 1fr) 96px 120px';
